module.exports = __webpack_public_path__ + "img/ahmed.eef9ac85.jpeg";